import { FunctionComponent, useEffect } from 'react';
import styles from "./ForgotPassword.module.css";
import {Image} from 'react-bootstrap';
import cn from 'classnames';
import AuthLayout from '../../../component/common/Layout/AuthLayout/AuthLayout';
import FormField, { IFieldType } from '../../../component/common/FormField/FormField';
import { PageRoutes } from '../../../routing/paths';
import { useNavigate } from "react-router-dom";
import { ASSESTS } from '../../../constant/assest';
import { useDispatch, useSelector } from 'react-redux';
import { forgotPassword } from '../../../redux/slices/auth/actions';
import { clearMessage, clearError }  from '../../../redux/slices/auth/slice';
import { AppDispatch, RootState } from '../../../redux/store';
import { toast } from 'react-toastify';
import { useFormik } from 'formik';
import { forgotPasswordSchema } from '../../../validation/authValidation';

const ForgotPassword: FunctionComponent = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();
    const { loading, error, message } = useSelector((state: RootState) => state.auth);

    const formik = useFormik({
        initialValues: {
            email: '',
        },
        validationSchema: forgotPasswordSchema,
        onSubmit: values => {
            dispatch(forgotPassword({ email: values.email }));
        },
    });

    const handleBlurWithTrim = (e: React.FocusEvent<HTMLInputElement>) => {
        formik.handleBlur(e); // for touched state
        const { name, value } = e.target;
        const trimmedValue = value.trim();

        if (value !== trimmedValue) {
            // Create a fake change event to update the value via formik.handleChange
            const fakeChangeEvent = {
                target: {
                    name: name,
                    value: trimmedValue,
                },
            };
            formik.handleChange(fakeChangeEvent);
        }
    };

    useEffect(() => {
        if (message) {
            toast.success(message);
            dispatch(clearMessage());
            navigate(PageRoutes.LOGIN);
        }
    }, [message, navigate, dispatch]);

    useEffect(() => {
        if (error) {
           toast.error(error);
           dispatch(clearError());
        }
    }, [error,dispatch]);

    return (
        <AuthLayout>
            <div className={styles.logo}>
                <Image 
                    src={ASSESTS.LOGO}
                    width={291}
                    height={73}
                    alt="Fishinity"
                />
            </div>
            <div className={styles.header}>Forgot Password</div>
            <form onSubmit={formik.handleSubmit} className={styles.form}>
                <FormField 
                    label='Email'
                    placeholder='Enter Email Address'
                    fieldType={IFieldType.EMAIL} 
                    className={styles.mb4}
                    name="email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={handleBlurWithTrim}
                    errorText={formik.errors.email}
                    showError={!!(formik.touched.email && formik.errors.email)}
                />
                <div className={cn(styles.submit, styles.mb4)}>
                    <button 
                        type="submit"
                        className='customBtn greenBtn'
                        disabled={loading === 'pending'}
                    >
                        {loading === 'pending' ? 'Sending...' : 'Send'}
                    </button>
                </div>
            </form>
        </AuthLayout>
    );
};

export default ForgotPassword;